// MessageDialogContext.js
import React, { createContext, useContext, useState } from 'react';
import { Modal, Button } from 'antd';
import PropTypes from 'prop-types';
const { confirm } = Modal;


const MessageDialogContext = createContext();


export const useMessageDialog = () => {
    return useContext(MessageDialogContext);
};


export const MessageDialogProvider = ({ children }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [dialogTitle, setDialogTitle] = useState('');
    const [dialogContent, setDialogContent] = useState('');
    const [dialogWidth, setDialogWidth] = useState(400);
    const [onOkCallback, setOnOkCallback] = useState(null);

    /**
     * Opens the message dialog.
     * @param {string} title - The title of the dialog.
     * @param {string} html - The HTML content to display inside the dialog.
     * @param {number} width - The width of the dialog.
     * @param {function} onOk - Optional callback function to execute on "Ok" button click.
     */
    const openMessageDialog = (title, html, width = 400, onOk = null) => {
        setDialogTitle(title);
        setDialogContent(html);
        setDialogWidth(width);
        setOnOkCallback(() => onOk); // Store the callback
        setIsVisible(true);
    };

    /**
     * Closes the message dialog and clears the callback.
     */
    const closeMessageDialog = () => {
        setIsVisible(false);
        setOnOkCallback(null);
    };

    /**
     * Handles the "Ok" button click.
     * Executes the callback if provided, then closes the dialog.
     */
    const handleOk = () => {
        if (onOkCallback) {
            onOkCallback();
        }
        closeMessageDialog();
    };

    return (
        <MessageDialogContext.Provider value={{ openMessageDialog }}>
            {children}
            <Modal
                title={dialogTitle}
                open={isVisible}
                onCancel={closeMessageDialog}
                footer={[
                    <Button key="close" onClick={closeMessageDialog}>
                        Close
                    </Button>,
                    <Button key="ok" type="primary" onClick={handleOk}>
                        Ok
                    </Button>,
                ]}
                width={dialogWidth}
                destroyOnHidden
            >
                {/* Render HTML content safely */}
                <div dangerouslySetInnerHTML={{ __html: dialogContent }} />
            </Modal>
        </MessageDialogContext.Provider>
    );
};

MessageDialogProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
